import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'media',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'media',
				),
			store,
			'MEDIA',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Media/index.js